import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

const amount = localStorage.getItem("busUser")
  ? JSON.parse(localStorage.getItem("busUser")).amount
  : "";

export const getAccountBalanceInfo = createAsyncThunk(
  "manageFunds/getAccountBalanceInfo",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getAccountBalanceInfo?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBankDetailsByOrgId = createAsyncThunk(
  "manageFunds/getBankDetailsByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getBankDetailsByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEscrowDetailsByOrgId = createAsyncThunk(
  "manageFunds/getEscrowDetailsByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getEscrowDetailsByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAccountTxnHistory = createAsyncThunk(
  "manageFunds/getAccountTxnHistory",
  async (params, { rejectWithValue }) => {
    const { withdraw, deposit, dealPurchase, dealRepayment } = params;
    try {
      const response = await axios.get(
        `/api/business/getAccountTxnHistory?withdraw=${withdraw}&deposit=${deposit}&dealPurchase=${dealPurchase}&dealRepayment=${dealRepayment}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBalanceByOrgId = createAsyncThunk(
  "manageFunds/getBalanceByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getBalanceByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const withdraw = createAsyncThunk(
  "manageFunds/withdraw",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/business/withdraw`, payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const manageFundSlice = createSlice({
  name: "manageFunds",
  initialState: {
    accBalance: { amount: amount },
    availableBalance: {},
    bankDetailsData: [],
    escrowBankDetailsData: {},
    txnHistoryData: [],
    loading: false,
    error: null,
    withdrawLoading: false,
    withdrawError: null
  },

  extraReducers: (builder) => {
    builder.addCase(getBalanceByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBalanceByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.accBalance = action.payload;
      state.error = null;
    });
    builder.addCase(getBalanceByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.accBalance = [];
      state.error = action.payload;
    });

    builder.addCase(getAccountBalanceInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAccountBalanceInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.availableBalance = action.payload;
      state.error = null;
    });
    builder.addCase(getAccountBalanceInfo.rejected, (state, action) => {
      state.loading = false;
      state.availableBalance = [];
      state.error = action.payload;
    });

    builder.addCase(getBankDetailsByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBankDetailsByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.bankDetailsData = action.payload;
      state.error = null;
    });
    builder.addCase(getBankDetailsByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.bankDetailsData = [];
      state.error = action.payload;
    });

    builder.addCase(getEscrowDetailsByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getEscrowDetailsByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.escrowBankDetailsData = action.payload;
      state.error = null;
    });
    builder.addCase(getEscrowDetailsByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.escrowBankDetailsData = {};
      state.error = action.payload;
    });

    builder.addCase(getAccountTxnHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAccountTxnHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.txnHistoryData = action.payload;
      state.error = null;
    });
    builder.addCase(getAccountTxnHistory.rejected, (state, action) => {
      state.loading = false;
      state.txnHistoryData = [];
      state.error = action.payload;
    });

    builder.addCase(withdraw.pending, (state) => {
      state.withdrawLoading = true;
      state.withdrawError = null;
    });
    builder.addCase(withdraw.fulfilled, (state, action) => {
      state.withdrawLoading = false;
      state.withdrawError = null;
    });
    builder.addCase(withdraw.rejected, (state, action) => {
      state.withdrawLoading = false;
      state.withdrawError = action.payload;
    });
  },
  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const {} = manageFundSlice.actions;

export default manageFundSlice.reducer;
